import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useState } from "react";
import { APP_BASE_URL, LOGOUT_URL } from "../../../../Common/EndPoints";
import { getLocalStorage } from "../../../../Utils/storage-utils";
import axios from "axios";
import toast from "react-hot-toast";
import useFirebaseCloudMessaging from "../../../../hooks/fcm/useFirebaseCloudMessaging";
import { useDispatch } from "react-redux";
import { logoutSuccess } from "../../../../features/authentication/auth-slice";
import useLogout from "../../../Login/useLogout";

function LogoutPopup({ open, onClose }) {
  //   const [loading, setLoading] = useState(false);

  const [loAllDevices, setLoAllDevices] = useState(false);
  const { loading, handleLogout } = useLogout();

  const handleLogoutSubmit = async () => {
    handleLogout(getLocalStorage("userId"), loAllDevices);
  };
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="responsive-dialog-title">
      <DialogTitle
        id="responsive-dialog-title"
        className="flex spaceBetween "
        //   sx={{ backgroundColor: "rgb(179 163 163 / 40%)" }}
      >
        <div>Logging out</div>
        <div className="flex items-center gap-2">
          <CloseIcon sx={{ cursor: "pointer", padding: "1px 3px" }} onClick={onClose} />
        </div>
      </DialogTitle>

      <DialogContent dividers>
        {loading ? (
          "Logging Out..."
        ) : (
          <>
            <DialogContentText>Do you want to logout?</DialogContentText>
            <FormControlLabel
              control={
                <Checkbox
                  checked={loAllDevices}
                  onChange={(event) => {
                    setLoAllDevices(event.target.checked);
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
              label="Logout from all devices"
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button color="error" variant="contained" onClick={handleLogoutSubmit}>
          {loading ? (
            <CircularProgress
              sx={{ width: "70% !important", height: "70% !important", color: "white" }}
              size={"small"}
            />
          ) : (
            "Logout"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default LogoutPopup;
